import { Button, Checkbox, Form, Input,InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Index = ({onNextStep}:any) => {
    //let navigate = useNavigate();
    const [checked, setChecked] = useState(false);
    const onChange = (e:any) => {
        console.log(`checked = ${e.target.checked}`);
        setChecked(e.target.checked)
    };

    const onClick = (e:any) => {
        // navigate("/register-account", { });
    
        onNextStep("register-account");
    };
      
    return (
        <div className='  p-5'>
            <div >
                <div className='agreement-container'>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <span>
                        <img
                        width={167}
                        height={35}
                        alt="image"
                        src="https://www.utrade.com.my/admin/temp/tnc/General and eDoc TC/Image_001.jpg"
                        />
                    </span>
                    </p>
                    <h1
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "14pt",
                        textIndent: "0pt",
                        lineHeight: "13pt",
                        textAlign: "left",
                    }}
                    >
                    <a name="bookmark0">UOB KAY HIAN ( M) SDN BHD </a>
                    <span className="s1">(194990-K)</span>
                    </h1>
                    <p
                    className="s2"
                    style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "left" }}
                    >
                    A Participating Organisation of Bursa Malaysia Securities Berhad A
                    Trading Participant of Bursa Malaysia Derivatives Berhad
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    className="s3"
                    style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "left" }}
                    >
                    Suite 19.01, Menara Keck Seng, 203 Jalan Bukit Bintang, 55100 Kuala
                    Lumpur, Malaysia. Tel:+603 2147 1888 Fax:+603 2147 1889
                    </p>
                    <p style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "left" }}>
                    <a href="http://www.uobkayhian.com.my/" className="a" target="_blank">
                        Website:{" "}
                    </a>
                    <a href="http://www.uobkayhian.com.my/" target="_blank">
                        www.uobkayhian.com.my
                    </a>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{
                        paddingTop: "4pt",
                        paddingLeft: "12pt",
                        textIndent: "0pt",
                        textAlign: "left",
                    }}
                    >
                    <span className="s4" style={{ backgroundColor: "#C0C0C0" }}>
                        {" "}
                        TERMS AND CONDITIONS FOR UTRADE{" "}
                    </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{
                        paddingTop: "4pt",
                        paddingLeft: "14pt",
                        textIndent: "0pt",
                        textAlign: "justify",
                    }}
                    >
                    This document and the Client’s Application Form for Individual/Corporate
                    Applicant collectively form the Agreement between the Client and UOB Kay
                    Hian (M) Sdn. Bhd (Company). The Applicant (Client) is at all
                    material time, a customer of the Company and have opened or applied to
                    open a Trading Account with the Company. The Client desires the rights
                    to access and use the website and subscribe to the Services.
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "justify" }}
                    >
                    This document contains additional terms and conditions applying to the
                    Client’s subscription to UOB Kay Hian Securities (M) Sdn. Bhd. UTRADE a
                    online trading system with a package of electronic investor facilities.
                    The Terms and Conditions herein shall include but not limited to the
                    Covenants and Undertaking in the Application Form for
                    Individual/Corporate Applicant and/or the agreement(s) executed between
                    the Client and the Company relating to the products and services by the
                    Company and the terms and conditions therein and all supplements,
                    amendments and variations thereto shall collectively constitute the
                    contract between the Client and the Company and shall apply to the
                    Service herein.
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "justify" }}
                    >
                    UOB KAY HIAN ( M ) S D N BHD (“Company”) in collaboration
                    with its appointed service provider (“Service Provider”) had introduced
                    U T R A D E , an online financial and stockbroking website under such
                    domain name (and/or any other name to be determined by the Company from
                    time to time) with a uniform resource locator (and/or any other uniform
                    resource locator or website to be determined by the Company from time to
                    time) (“Website”). The website is directed to the investor, or those
                    seeking information on investing and which comprises of a variety of
                    areas dedicated to providing investment- related information and
                    services (“Services”).
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "justify" }}
                    >
                    In consideration of the Company granting you these said rights, the
                    Client hereby agree to the terms and conditions contained herein (as may
                    be amended from time to time) which shall govern their access to and use
                    of the website and subscription to the Services.
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
            
                    <ol id="l1" className="order-number">
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>PROVISION OF SERVICES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l2" className="order-number">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Services provided by the Company consists of:-
                            </p>
                            <ul id="l3">
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "justify",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                online electronic trading systems whereby the Client may
                                buy, sell, deal in or otherwise trade securities via the
                                website in the Bursa Malaysia Securities Berhad (“Bursa”)
                                and/or any stock exchange as may be approved by the Company
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                            </li>
                            </ul>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company will provide any or all of the following facilities
                            to the Client depending on the extent of the Client’s
                            subscription to the Services:-
                            </p>
                            <ul id="l4">
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Access to real time quotes
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>Access to online trading</p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Access to financial informations and charts
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Access to financial News and Views
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Access to account informations and portfolios
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                View Trading Account statement and aging report
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Custody and Nominees Services
                                </p>
                            </li>
                            </ul>
                            <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "41pt",
                                textIndent: "0pt",
                                textAlign: "left",
                            }}
                            >
                            plus any other facilities that may be introduced by the Company
                            from time to time at their absolute discretion, and the Client
                            has the option to subscribe to any one or more or any
                            combination of the above named services.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            In consideration of the Client paying to the Company the fees
                            pursuant to Clause 10 hereof and complying with these Terms
                            &amp; Conditions, the Company will provide the Client any one or
                            more of the services set out in Clause 1.1 above as the Client
                            may elect.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client’s subscription to the Services shall be for a minimum
                            period of One (1) year.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Notwithstanding the above, the Company may at any time and from
                            time to time, vary or change the list of facilities herein above
                            mentioned without giving any notice thereof to the Client. Any
                            variation or change in the list of facilities imposed by the
                            Company pursuant to this provision shall upon such variation or
                            change be deemed to be part of the Services and shall not in any
                            manner affect the other terms and condition stated herein.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall open and maintain an online account (UTRADE)
                            which the Client shall use for the purposes of, among others,
                            executing buy, sell, and trade or deal orders for the securities
                            (“Orders”). The Client shall execute the application form
                            provided by the Company (“Application Form”) and submit the same
                            for approval by the Company. Upon the Company’s approval, the
                            Client shall be assigned a username and Personal Identification
                            Number (“PIN”) for the purposes of accessing the Client’s UTRADE
                            Account. The Client acknowledges that the Company may, at its
                            own discretion, reject the Client’s application without
                            assigning any reasons for doing so and without any liability
                            whatsoever to the Client.
                            </p>
                        </li>
                        <li
                            style={{
                            paddingTop: "4pt",
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall be solely responsible for the security and
                            privacy of the Client’s username and PIN, as well as the UTRADE
                            Account. The Client acknowledges that the Company may, from time
                            to time and at its sole discretion, access the Client’s Online
                            Account for the purposes of audit or inspection.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company grants to the Client a non-exclusive license to use
                            the Service’s software (“Software”) on any computer and/or
                            electronic device and/or communication media of which the Client
                            is the primary user. The services shall be used strictly and
                            solely for the Client and shall not be extended for use by third
                            parties for whatsoever reason. The Company forbids any copying
                            of Software or associated written materials. The Client agrees
                            not to sublicense, assign or transfer this license or the
                            Software.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>MEDIA OF SERVICES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l5">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall access the Website to utilise the Services
                            mentioned in Clause 1 above by using one or any of the following
                            media:-
                            </p>
                            <ul id="l6">
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "55pt",
                                textIndent: "-14pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Modem-equipped terminal or personal computer;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "55pt",
                                textIndent: "-14pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Any other medium of communication which the Company may, in
                                its absolute discretion, adopt or introduce for use to its
                                Clients.
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                            </li>
                            </ul>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees that should the Client experience difficulties
                            in using one of the medias of service listed in Clause 2.1, the
                            Client shall attempt to use alternate methods to communicate
                            with the Company.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client further agrees that the Company may keep a record of
                            all communication (including any transactions) between the
                            Company and the Client for any purpose including to verify any
                            information exchanged between the parties and to monitor the
                            quality of the Services or to collect date to anticipate the
                            Client’s future financial requirements.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>
                        NO GUARANTEE OR WARRANTY &amp; LIMITATION OF COMPANY’S LIABILITY
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l7">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client hereby acknowledge that the data, information,
                            messages and other content (“Information”) disseminated and
                            provided through the Services to the Client derive either
                            directly from the Company, the Exchange and/or been
                            independently obtained by the Company through sources believed
                            by the Company to be reliable including authorised dissemination
                            agents of the Bursa and independent information providers.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Whilst the Company make every effort to ensure the accuracy of
                            the information provided through the Service, the Client
                            acknowledges that the information, materials and contents
                            provided on the Website are on “as is” basis and are of a
                            general nature. The Company, the Service Provider and the
                            Company’s information providers, licensors, employees or agents
                            do not guarantee the correctness, accuracy, completeness,
                            timeless or correct sequencing of any such Information
                            disseminated and/or provided by any party through the Services.
                            It shall be the Client’s obligation to take independent legal,
                            financial or other advice as the Client shall deem necessary.
                            The Client is advised to verify the correctness, accuracy,
                            timeliness and correct sequencing of all such Information and
                            the Client shall be deemed to have done so, whether the Client
                            has in fact done so or not. The Client further acknowledges that
                            there may be delays, omissions or inaccuracies in the
                            Information provided under these Services which neither the
                            Company nor the Service Provider shall be responsible or liable
                            for.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company does not warrant the merchantability or fitness for
                            a particular purpose or use and gives no other warranty or
                            guarantee of any kind, either express or implied, regarding the
                            Information furnished under the Services or any other aspect
                            thereof, including but not limited to date, Information,
                            messages, or access, or the execution, cancellation or amendment
                            of any Orders, and the Client further agrees that the Company,
                            the Service Provider and the Company’s information providers,
                            licensors, employees or agents shall not be liable for any
                            direct, consequential, incidental or indirect losses or damages
                            whatsoever which may arise or be caused by the failure or
                            alleged failure of the Company to execute, cancel or amend such
                            Orders.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>
                        DISCLAIMER AND LIMITATION OF COMPANY’S LIABILITY
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l8">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Due to the nature of electronic equipments, mobile devices and
                            other communication media, the Company do not warrant that the
                            operation of the Service will be uninterrupted and entirely
                            error free. Furthermore problems related to connection
                            difficulties endemic with internet and mobile application, from
                            time to time may result the Service subject to error or failure.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            In addition to and not in derogation of any other terms of this
                            Agreement, the Client acknowledges that, in providing the
                            Services, the Company, the Service Provider and the Company’s
                            information providers, licensors, employees or agents shall not,
                            in any event, be liable to the Client or any other parties
                            having access to the Services whether with or without the
                            Company’s consent for any direct, consequential, incidental or
                            indirect losses or damage (including but not limited to loss of
                            profits, trading losses and damages) that results from any
                            inconvenience, delay or loss arising from the use of the
                            Services, access to the Client’s UTRADE Account, or any of the
                            circumstances enumerated in this Clause, regardless of whether
                            the Company has been advised of the possibility of such damages
                            or losses.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "39pt",
                            textIndent: "-24pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client further agrees that the Company, the Service Provider
                            and the Company’s informations, providers,
                            </p>
                            <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "41pt",
                                textIndent: "0pt",
                                textAlign: "justify",
                            }}
                            >
                            licensors, employees or agents shall not be liable for any loss
                            resulting from a cause over which they have no direct control,
                            including but not limited to failure of electronic or mechanical
                            equipment or telecommunication lines, telephones or any other
                            interconnect problems, unauthorised access, unathorised use of
                            the password, theft, operator errors, weather, earthquakes,
                            floods and strikes or other labour problems.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company do not accept any liability whether in contract or
                            in tort (including negligence) for damage to the electronic
                            equipment and/or mobile device or for any loss of functionality
                            that results from use of the Service and the Company do not
                            guarantee that any downloads are free from viruses or for any
                            problem the Client may experience with the electronic equipment,
                            mobile device or any other software.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees that the liability of the Company to the
                            Client arising out of any kind of legal claim in whatsoever way
                            connected with or arising from the Company’s Services and the
                            Client’s use of the Information provided thereunder shall not
                            exceed the monthly fee (if any) paid by the Client for the
                            Client’s access to and use of the Website and the Client’s
                            subscription of the Services herein.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>
                        ORDERS AND CANCELLATION REQUESTS
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l9">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees that any Order(s) received by the Company
                            through the use of the Client’s UTRADE Account (accessed via the
                            Client’s username and PIN) shall be deemed to have been issued
                            by the Client notwithstanding that such order(s) may have been
                            issued by a third party, whether authorised or otherwise.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that the confirmation of the receipt
                            and/or execution of such Order(s) as reflected in the Website
                            shall be deemed conclusive of:-
                            </p>
                            <ul id="l10">
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "72pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the receipt by the Company of the order; and
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "72pt",
                                textIndent: "-17pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                that the consent necessary for such Order(s) is as received
                                by the Company; and
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "72pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                that such Order(s) may be relied upon and acted on by the
                                Company without further reference to or verification from
                                the Client and without liability whatsoever to the Client.
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                            </li>
                            </ul>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees to review the relevant page confirmation views
                            in the Website to ascertain that the Order(s) were correctly
                            received by the Company and processed under these Services.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that not all trades will be executed
                            concurrently with the Order(s) issued by the Client. The Client
                            further acknowledges and accepts, without liability of the
                            Company, its employees or agents, that there will be times when
                            a quoted price will change prior to the trade’s execution due to
                            market circumstances or factors outside the control of the
                            Company.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that a request to cancel an earlier
                            Order is not guaranteed by the Company as the earlier Order can
                            only be cancelled if the cancellation request is received and
                            effected before the said earlier Order is executed.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client also acknowledges that while Company reserves the
                            sole right to review all Orders executed by the Client pursuant
                            to these Services, the Company shall neither be obliged nor
                            required to do so. Accordingly, the Company shall neither be
                            responsible nor liable for any mistakes, inaccuracies or
                            incompleteness in such Orders, whether due to an error caused by
                            the Client or as a result of any other reason whatsoever.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>
                        LICENSE &amp; TITLE TO INFORMATION/PROPRIETARY RIGHTS
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l11">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Subject to the terms of this Agreement, the Company grants to
                            the Client a personal, non- exclusive, non-assignable and
                            non-transferable licence to use and display the Services’
                            software or website (whichever is applicable) (“Software”) on
                            any computer of which the Client is the primary user.
                            Unauthorised copying of the Software, including software that
                            has been modified, merged or included with the Software, or the
                            written materials associated therewith is expressly prohibited
                            without the prior written consent of the Company. The Client
                            agrees not to sublicense, assign or transfer this license or the
                            Software and any attempt to do so shall be considered to be null
                            and void.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that the Company, the Exchange and
                            participating information providers assert a proprietary right
                            over the Information disseminated through and/or provided by the
                            Services. The Client agrees not to reproduce, retransmit,
                            disseminate, sell, distribute, publish, broadcast, circulate or
                            exploit, whether for commercial purposes or otherwise, the
                            Information in any manner whatsoever without the express written
                            consent of the Company nor use the Information for any illegal
                            or illicit purpose.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees that it shall protect the contractual,
                            statutory and intellectual property rights of the Company, the
                            Exchange and participating information providers in or to the
                            Information furnished under the Services and in the Services
                            themselves and shall comply with all written requests from the
                            parties hereinbefore mentioned as they deem necessary to protect
                            their respective rights.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The client hereby authorize Bursa Malaysia Depository Sdn Bhd
                            (“Bursa Depository”) to disclose to the Company, and/or agents,
                            service providers and sub-contractors of the Company on
                            information and/or documents pertaining to the affairs of the
                            client's account with Bursa Depository, and in particular, with
                            relation to the portfolio held in the client's account. This
                            </p>
                            <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "41pt",
                                textIndent: "0pt",
                                textAlign: "justify",
                            }}
                            >
                            authorization shall continue to be valid unless revoked by the
                            client in writing. The client release Bursa Depository from any
                            losses and/or liabilities arising from or in connection with
                            this authorization, with the exception of losses/liabilities
                            arising from any act, statement or omission that was not
                            conducted in good faith by Bursa Depository.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>CLIENT’S SOLE RISK</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l12">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that neither the Services nor the
                            Information provided thereunder is intended to amount to or
                            constitute any financial, business, tax or legal advice.
                            Although the Service provides access to opinions, Information
                            and recommendations about the economy, stock market, how to
                            invest and what stocks to buy, the Services shall not be
                            construed as amounting to offers, invitations or solicitations
                            to buy, sell or otherwise trade in the securities concerned. The
                            Company does not warrant the accuracy stated in any manner of
                            the opinions, Information and recommendations, and no reliance
                            whatsoever by the Client on the matters aforementioned shall
                            give rise to any claim whatsoever.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company neither recommends any investment nor does it offer
                            any advice regarding the nature, potential value or suitability
                            of any particular security, transaction or investment strategy.
                            The Client acknowledges that all Orders made by it through the
                            Services and executed by the Company pursuant thereto are made
                            at the Client’s sole and absolute risk.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that the Exchange is the regulatory and
                            supervisory authority of the Company and that the Exchange
                            shall, at all material times, have the right to examine,
                            inspect, scrutinise the Client’s terminals for audit and other
                            supervisory purposes as and when they deem fit subject to such
                            examination, inspection or scrutinisation being carried out at
                            reasonable hours. The Client acknowledges that it shall not hold
                            the Company liable for any liability and/or losses that may
                            occur as a result of the actions and omissions of the Company
                            and/or the Exchange.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>NOTIFICATION BY CLIENT</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l13">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Without prejudice to any other provisions herein, the Client
                            agrees that it shall notify the Company immediately and, in any
                            case, no later than twenty four (24) hours from the time the
                            Client should have become aware of the existence of any of the
                            following:-
                            </p>
                            <ul id="l14">
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "68pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                any loss or theft of the installation disk;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "68pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                any unauthorised access of the Client’s UTRADE Account, use
                                of the Client’s username or PIN, or of the Services or any
                                information obtained thereunder;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "68pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                any failed or incorrect receipt of an Order initiated by the
                                Client through the Services upon the Client’s review of the
                                Trade Confirmation View of the Services;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "68pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                any receipt of confirmation (whether electronic, written or
                                otherwise) of business done of an Order which the Client did
                                not place or any receipt or inaccurate or conflicting report
                                or information.
                                </p>
                                <ul id="l15">
                                <li
                                    style={{
                                    paddingTop: "2pt",
                                    paddingLeft: "68pt",
                                    textIndent: "-18pt",
                                    textAlign: "left",
                                    }}
                                >
                                    <p style={{ display: "inline" }}>
                                    disruption in the provision of the Service; and
                                    </p>
                                </li>
                                <li
                                    style={{
                                    paddingTop: "3pt",
                                    paddingLeft: "68pt",
                                    textIndent: "-18pt",
                                    textAlign: "left",
                                    }}
                                >
                                    <p style={{ display: "inline" }}>
                                    changes in personal particulars including but not
                                    limited to the location of the Company’s UTRADE
                                    terminal.
                                    </p>
                                </li>
                                </ul>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                                <p
                                style={{
                                    paddingLeft: "55pt",
                                    textIndent: "0pt",
                                    textAlign: "left",
                                }}
                                >
                                In all such cases, the Company reserves the right to
                                determine the validity of the Client’s objection to a
                                transaction arising from, but not limited to, the above.
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                            </li>
                            </ul>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Should the Client fail to notify the Company in the time
                            specified in Clause 8.1 above of the occurrence of any of the
                            above incidents, neither the Company nor any of its information
                            providers, licensors, employees or agents, shall be responsible
                            and/or liable to the Client or any other party whose claim may
                            arise through the Client for any claims with respect to
                            handling, mishandling or the loss of any Order. For the
                            avoidance of doubt, the Client acknowledges that its notifying
                            of the Company in Clause 8.1 shall not render the Company
                            responsible or liable whatsoever for any of the situations
                            stated thereto.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>CONFIDENTIALITY</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l16">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            When using the Service, the username, password and account
                            number are extremely sensitive informations. The Client shall be
                            responsible for the confidentiality, security and safe storage
                            and use of its username and PIN. The Client further accepts full
                            and absolute responsibility for all Orders entered through the
                            Client’s UTRADE Account via the use of the Client’s username and
                            PIN. All Orders so received by the Company pursuant thereto
                            shall be deemed to have been received from the Client and are
                            the valid and correct instructions of the Client.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall be solely responsible to review the
                            confirmation of Business Done to ascertain that the orders were
                            correctly placed through the Service and that a transaction
                            reference number has been duly issued immediately through the
                            Service upon placing an order to buy or sell.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>FEES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l17">
                        <li
                            style={{
                            paddingLeft: "44pt",
                            textIndent: "-30pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees to pay and authorises the Company to debit its
                            Trading Account with the following fees, if any:-
                            </p>
                            <ul id="l18">
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "72pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                All subscription, service and use fees as prescribed by the
                                Company, wherein the said subscription fees are payable
                                monthly in advance, and none of the said fees are
                                refundable.
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "72pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Any other reasonable fees, cost, expenses and charges
                                imposed by the Company from time to time for services
                                </p>
                                <p
                                style={{
                                    paddingTop: "3pt",
                                    paddingLeft: "72pt",
                                    textIndent: "0pt",
                                    textAlign: "left",
                                }}
                                >
                                and facilities rendered to the Client.
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "72pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Interest on all outstanding sums due from the Client
                                hereunder at such rate and at such mode as the Company shall
                                stipulate.
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "72pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                Legal fees and other expenses incurred by the Company in the
                                enforcement of the Company’s rights and entitlement under
                                this Agreement and the recoveries of the monies owed by the
                                Client to the Company.
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                <br />
                                </p>
                            </li>
                            </ul>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Notwithstanding the above provisions, the Company may at its
                            discretion vary the Fee or vary the rate of such fees and
                            subscriptions and vary the time and manner of payment of the
                            Fee, at any time and from time to time without notice to the
                            Client and without any liability whatsoever.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client agrees that the Company reserved the right to impose
                            additional fees in relation to the provision of the Services.
                            All fees shall be non-refundable, unless the Company agrees
                            otherwise. The Client authorises the Company to debit the
                            Client’s Trading Account with all Fees due and payable by the
                            Client.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            In the event the Client fai l s t o co mp l y t h e ab o ve t er
                            ms , the Company shall have the option of terminating this
                            Agreement in accordance with Clause 16 herein.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>CONTINUING SECURITY OF ASSETS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l19">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p className="s5" style={{ display: "inline" }}>
                            {" "}
                            <span className="p">
                                The Client agrees that it shall pay all costs (including
                                solicitor’s fees), if any, incurred by the Company in
                                collecting any overdue fees from the Client. The Client hereby
                                grants the Company a continuing security interests and/or lien
                                on the assets belonging to the Client in all its Trading
                                Accounts with the Company to secure the timely payment of all
                                the amounts owing under this Agreement by the Client and that
                                the Company shall be at liberty to use or dispose these assets
                                without prior notice to the Client in whatsoever manner and
                                upon such terms and conditions as the Company deems fit to
                                secure the full payment of such overdue fees, subject to any
                                rules that may be laid down by the Bursa or any other relevant
                                authority or under any applicable law in respect of such
                                matter.
                            </span>
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>TAXES &amp; CHARGES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l20">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall bear for all taxes and licence fees payable for
                            the use of the Services, if any.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company is not liable for any charges incurred by the Client
                            by using the Service, whether the charge is raised by the
                            Client’s internet service provider, mobile supplier or any other
                            party. The Client agrees that any cost incurred by using the
                            Service is the sole responsibility of the Client.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>RESTRICTIONS IN USE OF SERVICES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l21">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company reserves the right to determine whether the Client
                            is to trade via the Services on either Ready Basis Contracts or
                            Immediate Basis Contracts as provided for in the Rules of the
                            Bursa.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall not be entitled to use the Services offered by
                            the Company under this Agreement, if there exists any
                            restriction whatsoever on the Client’s Trading Account either
                            imposed by the Company or by any relevant authorities, including
                            but not limited to cash up- front restrictions. The provision of
                            the Service by the Company is subject to the terms and
                            conditions of any and all other agreements entered into between
                            the Company and the Client.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company shall not be held responsible for any failure to
                            provide the Services, including the execution of any Order
                            arising out of any restrictions imposed. While the Company may
                            inform the Client for such restrictions, the Client acknowledges
                            t h a t the Company is not obliged to do so and shall not be
                            responsible for its failure to do so.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>DEPOSIT</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l22">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company reserves the right to require the Client to place
                            cash and/or equity as deposit before the execution of any
                            transaction through the Services. It shall be in the absolute
                            discretion of the Company to determine the amount of deposit
                            payable by the Client and the time and manner for the placement
                            and nature of such deposit.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company reserves the right to require the Client to maintain
                            a minimum balance at any one time in the Client’s account. It
                            shall be at the absolute discretion of the Company to determine
                            the quantum of the said minimum balance to be so maintained. At
                            the Company’s absolute discretion, the Client’s failure to
                            maintain such minimum balance as stipulated by the Company would
                            entitle the Company to terminate this Agreement in accordance
                            with Clause 16 herein.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company reserves the right not to pay any interest for the
                            deposit placed by the Client as mentioned in Clause 14.1 above.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Company shall neither be held responsible nor liable for any
                            failure to provide or interruption in the Services arising out
                            of the Client’s failure, refusal or delay in placing such
                            deposit or in failing to maintain the minimum balance as
                            stipulated by the Company.
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingTop: "3pt",
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>INDEMNITY</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l23">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client unconditionally and irrevocably undertakes to fully
                            and effectively indemnify the Company and keep the Company
                            indemnified from and against any and all claims, losses
                            (including loss of profit), liabilities, obligations, penalties,
                            fines, costs and expenses (including but not limited to
                            solicitors fees on a solicitor and user basis) sustained by the
                            Company due to the execution by the Company of any buy or sell
                            orders given by the Client or any other party or parties having
                            access to the Service whether with or without the Client’s
                            consent or any breach or violation by the Client (or its agents
                            or representatives or persons acting under it) of any part of
                            these Terms &amp; Conditions or any third party rights including
                            but not limited to violation of any copyright, proprietary or
                            privacy rights. This obligation to indemnify the Company shall
                            survive the termination of the Service for any reason
                            whatsoever.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>TERMINATION OF RIGHT OF ACCESS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l24">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p className="s5" style={{ display: "inline" }}>
                            {" "}
                            <span className="p">
                                Notwithstanding anything herein to the contrary, the Company
                                may at any time, in its absolute discretion terminate
                                forthwith this Agreement, all or any part of the Services, the
                                Client’s right of access to and use of the Portal and the
                                Client’s subscription to the Services (or any portion thereof)
                                without notice and without compensation and without any
                                obligation to give any reasons for doing so, at anytime and
                                for any reason whatsoever including but not limited to any
                                unauthorised use of the Client’s username and PIN, not
                                agreeing to the levying of additional fees, or breach of any
                                terms and conditions of the Agreement in any manner whatsoever
                                whether by the Client or by any other person(s) whomsoever.
                            </span>
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            In the event of such termination by the Company in Clause 16.1,
                            the Company shall not be liable to the Client for any claims,
                            losses or anticipated profit which may be suffered by the Client
                            arising out of or in connection with such termination.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client may terminate the Service by giving the Company one
                            (1) month written notice of such intention.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Clauses 3, 7, 11 and 15 shall survive any termination of this
                            Agreement.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>REPRESENTATIONS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l25">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client represents and warrants to the Company that otherwise
                            as disclosed by the Client to the Company in writing and
                            accepted by the Company:-
                            </p>
                            <ul id="l26">
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "57pt",
                                textIndent: "-16pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client is not acting on behalf of a firm, corporation,
                                partnership, trust or association;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "57pt",
                                textIndent: "-18pt",
                                textAlign: "justify",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client is not a securities broker/dealer, investment
                                adviser, futures commission agent, commodities dealer or
                                commodity trading adviser, member of a securities exchange
                                or association: or futures exchange or an owner/partner or
                                associated person of any of the foregoing ;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "57pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client is not employed by a bank or any organisation or
                                corporation to perform functions related to securities or
                                commodities futures investment or trading activity; and
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-19pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client is a customer of the Company and maintains a
                                share trading account with the Company.
                                </p>
                            </li>
                            </ul>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client undertakes with the Company that as long as the
                            Client has access to the Service:-
                            </p>
                            <ul id="l27">
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client agrees to be bound by these Terms &amp;
                                Conditions as may be amended from time to time;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                unless otherwise agreed to in writing by the Company, the
                                Client will use the information provided through the Service
                                solely in connection with its personal investment activities
                                and not in connection with any trade or business activities;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the representations and warranties in Clause 17.1 above
                                shall remain true and accurate;
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "2pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client will not do anything to jeopardise the quality,
                                reliability or integrity of the Service; and
                                </p>
                            </li>
                            <li
                                style={{
                                paddingTop: "3pt",
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                the Client will comply with the Client Guide and such other
                                guidelines issued by the Company in connection with the
                                Service.
                                </p>
                            </li>
                            </ul>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-36pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Provided however, the above conditions shall not be applicable
                            in the event the Client has disclosed the existence of any of
                            the above circumstances and has provided the Company with the
                            relevant documents prior to the execution of the Application
                            Form. Provided further that where a corporate entity or a
                            partnership applies for the Services and the said corporate
                            entity or partnership is a client, the Client shall hereby
                            indemnify the Company against all losses or damages, direct or
                            consequential which may arise out of the action of any
                            representative(s) designated by such corporate entity or
                            partnership using the Services on behalf of the corporate entity
                            or partnership (whichever is applicable).
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "32pt",
                        textIndent: "-18pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>ACKNOWLEDGEMENT</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l28">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client acknowledges that the Company is providing the
                            Services on the basis of and on condition that the Client agrees
                            to be bound by the terms and conditions contained in this
                            Agreement. In addition to the terms and conditions contained in
                            this Agreement, the Client also acknowledges that there may be
                            other terms and conditions for the use of any of the Services in
                            the Website.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p className="s5" style={{ display: "inline" }}>
                            {" "}
                            <span className="p">
                                Subject to Clause 18.3 herein, the Client acknowledges that
                                the terms and conditions contained in this Agreement,
                                inclusive of the Application Form, constitutes the complete
                                statement of the Client’s agreement with
                            </span>
                            </p>
                            <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "41pt",
                                textIndent: "0pt",
                                textAlign: "justify",
                            }}
                            >
                            Company in respect of the Client’s access to and use of the
                            Website and the Client’s subscription to the Services, and that
                            the agreement does not include any other prior or
                            contemporaneous promises, representations or descriptions
                            regarding the Services regardless of whether they are contained
                            in any materials, documents or representations made or provided
                            by the Company.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client hereby agrees that the terms and conditions of this
                            Agreement shall be read together with any other agreement
                            relating to the trading of securities, entered into between the
                            Client and the Company.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>AMENDMENTS AND MODIFICATIONS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l29">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Notwithstanding Clause 18, the Company may in its absolute
                            discretion and without any prior notice (whether in writing or
                            otherwise) amend or vary the terms and conditions of this
                            Agreement hereunder at any time or from time to time or impose
                            any additional provisions, all of which shall be binding upon
                            the Client as if the amendments and additional clauses had been
                            originally set out in this Agreement.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>GOVERNING LAW</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l30">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            This Agreement and performance hereunder by the parties will be
                            governed by and construed in accordance with the laws of
                            Malaysia and the parties hereto submit to the exclusive
                            jurisdiction of the Malaysian Courts in all matters connected
                            with the obligations and the liabilities of the parties under
                            this Agreement.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>TIME</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l31">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Time wherever mentioned shall be of the essence of this
                            Agreement.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>SEVERABILITY</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l32">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Any term, condition, stipulation, provision, covenant or
                            undertaking herein which is illegal, void, prohibited or
                            unenforceable shall be ineffective to the extend of such
                            illegality, voidness, prohibition or unenforceability without
                            invalidating the remaining provisions hereof, and any such
                            illegality, voidness, prohibitions or unenforceability shall not
                            invalidate or render illegal, void or unenforceable any other
                            term, condition, stipulation, provision, covenant, or
                            undertaking herein contained.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>ASSIGNMENT &amp; SUCCESSORS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l33">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall not assign or transfer any of its rights or
                            obligations under this Agreement or any contract thereunder,
                            except with the Company’s prior written consent. The Client
                            hereby expressly consents to the Company assigning or
                            transferring any of its rights and obligations under this
                            Agreement or any contract thereunder in relation to the
                            provision of the service to any other party by written notice to
                            the Client. The Company may at any time, at its absolute
                            discretion and without notice change, replace or substitute its
                            Service Provider and/or appoint new or additional Service
                            Provider.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p className="s5" style={{ display: "inline" }}>
                            {" "}
                            <span className="p">
                                The terms and conditions of this Agreement shall be binding
                                upon the successors-in-title and permitted assigns of the
                                parties hereto.
                            </span>
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>BUYING IN AND SELLING OUT</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l34">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Notwithstanding the functionalities provided by the Software,
                            all the buying in and selling out, pertaining to the Bursa
                            Rules, shall be instituted solely by the Company’s Dealer’s
                            Representative.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client shall indemnify and keep the Company indemnified
                            against any losses incurred or arising from the above
                            transactions.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>WAIVER</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l35">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Except as specifically permitted in this Agreement, no
                            provision, term or clause of this Agreement will be waived,
                            altered, modified or amended unless agreed to and acknowledged
                            in writing by the Company that such waiver, alteration,
                            modification or amendment will take effect and be binding upon
                            both the Client and the Company.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>NOTIFICATION</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l36">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The Client hereby irrevocably consents to any notification to
                            the Client by the Company, where required under this Agreement
                            or where given under the Company’s discretion, in any one or
                            more of the following methods:-
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                            <ol id="l37">
                            <li
                                style={{
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                By email to the Client’s email address and in which case it
                                shall be deemed received by the Client the following day
                                after the said transmission.
                                </p>
                            </li>
                            <li
                                style={{
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                By fax to the Client’s fax number and in which case it shall
                                be deemed received by the Client the following day after the
                                said transmission.
                                </p>
                            </li>
                            <li
                                style={{
                                paddingLeft: "59pt",
                                textIndent: "-18pt",
                                textAlign: "left",
                                }}
                            >
                                <p style={{ display: "inline" }}>
                                By ordinary post to the Client’s last known address and in
                                which case it shall be deemed received by the Client within
                                two (2) days after the date of posting.
                                </p>
                            </li>
                            </ol>
                        </li>
                        <li
                            style={{
                            paddingTop: "3pt",
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "justify",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Any failure or delay on the part of the Company to give notice
                            to the Client in accordance with Clause 26.1 hereof, where
                            required under this Agreement, shall not prejudice or have the
                            effect of invalidating the subject matter of the notification
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            Any notification to be given by the Client to the Company shall
                            be sent to the Company either by way of personal service (duly
                            acknowledged receipt by the Company) or by way of registered
                            post.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>TRADING RULES</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l38">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            In relation to trading matters, the Terms and Conditions herein
                            contained are read in conjunction with the Covenants and
                            Undertaking of the Trading Account and Bursa Rules.
                            </p>
                            <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                            </p>
                        </li>
                        </ol>
                    </li>
                    <li
                        style={{
                        paddingLeft: "41pt",
                        textIndent: "-27pt",
                        textAlign: "left",
                        }}
                    >
                        <h2 style={{ display: "inline" }}>HEADINGS</h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <ol id="l39">
                        <li
                            style={{
                            paddingLeft: "41pt",
                            textIndent: "-27pt",
                            textAlign: "left",
                            }}
                        >
                            <p style={{ display: "inline" }}>
                            The headings of each provision, clause, or term, of this
                            Agreement are meant for reference only and shall not be deemed
                            to modify or qualify any of the rights or obligations set forth
                            in each such provision, clause or term herein.
                            </p>
                        </li>
                        </ol>
                    </li>
                    </ol>
                    <p
                    className="s6"
                    style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "right" }}
                    >
                    <a name="bookmark1">eContract.eStatement.TnC.v1.10July2015</a>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    style={{
                        paddingTop: "4pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left",
                    }}
                    >
                    <span className="s4" style={{ backgroundColor: "#C0C0C0" }}>
                        {" "}
                        TERMS &amp; CONDITIONS ECONTRACT AND ESTATEMENT{" "}
                    </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                    </p>
                    <p
                    className="s7"
                    style={{
                        paddingTop: "4pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                    }}
                    >
                    <a href="http://www.utrade.com.my/" className="s9" target="_blank">
                        In consideration of UOB Kay Hian (M) Sdn Bhd ("UOBKH")
                        agreeing at the client's request that future contracts and statements
                        will be available to the client through the UTRADE website,{" "}
                    </a>
                    <a href="http://www.utrade.com.my/" className="s8" target="_blank">
                        www.utrade.com.my
                    </a>
                    , upon login to the client's online trading account (known as the
                    "Service"), and the client hereby agrees as follows:
                    </p>
                    <ol id="l40" className="order-number">
                    <li
                        style={{
                        paddingTop: "9pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client shall agree to the terms and conditions relating to the
                        Service as herein after provided, and the client confirms that these
                        shall be in addition to and not in substitution of UOB Kay Hian's
                        standard terms and conditions governing its facilities and to the
                        services which shall apply to the Service as if the said terms and
                        conditions were repeated herein. In the event of a conflict between
                        the terms and conditions of this agreement and any other relevant
                        terms and conditions, the terms and conditions of this agreement
                        will prevail to the extent of such conflict. The use of the Service
                        will constitute the client's agreement to and receipt of these terms
                        and conditions as well as the acknowledgement of the inherent risks
                        in the transmission of eStatement and eContract online.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "9pt",
                        paddingLeft: "25pt",
                        textIndent: "3pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The provision of this Service is at the UOBKH's discretion, and such
                        Service may be modified, suspended, withdrawn, cancelled or
                        discontinued by UOBKH at any time. In the event of such
                        modification, suspension, withdrawal, cancellation or discontinuance
                        of the Service, UOBKH shall notify the client and shall revert to
                        sending the statements in paper format to the client's last mailing
                        address appearing on UOBKH's record. In the case of eContract, the
                        eContract shall be available on UTRADE after login for 14 days. Once
                        the Service is provided to the customer, UOBKH will cease to provide
                        the client with printed and mailed contracts and statements after
                        October 1, 2015.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "10pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client is the designated user of his/her UTRADE account and
                        shall take all necessary security measures and precaution to ensure
                        that the User ID and Password to the UTRADE account is not accessed
                        by any unauthorized party.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "10pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client may terminate the Service at any time by submitting a
                        request in writing via post or email. The client understands that
                        UOBKH will revert to sending the statements in paper format to the
                        last mailing address appearing on UOBKH's records.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "9pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client will be required to check all eContracts or eStatements
                        for any unauthorized transactions. If the client should be aware of
                        any unauthorized transaction(s) on any of the eContracts or
                        eStatements, the client must notify UOBKH as soon as reasonably
                        practicable but in any event not later than the stipulated
                        applicable time period specified in the eContract and/ or in the
                        eStatement. Any applicable time periods within which the client must
                        notify UOBKH of any unauthorized transaction(s) shall begin on the
                        statement date printed on the relevant eContract and/or eStatement
                        regardless of when the client accesses or opens the eContract and/or
                        eStatement.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "10pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client acknowledges that UOBKH will use its best endeavours to
                        ensure the security of the Service. Notwithstanding the foregoing,
                        the client agrees that UOBKH shall not be liable in any manner for
                        any disruption, unavailability of the Service, communication,
                        electrical or network failure that may result in the eContracts or
                        Statements being incomplete, unavailable or delayed in transmission.
                        The client further acknowledges that the use of and the transmission
                        of information via email may not be guaranteed to be secure. The
                        client acknowledges that the information transmitted may be liable
                        to errors, viruses, delay,
                        </p>
                        <p
                        className="s6"
                        style={{
                            paddingTop: "2pt",
                            paddingLeft: "342pt",
                            textIndent: "0pt",
                            textAlign: "left",
                        }}
                        >
                        eContract.eStatement.TnC.v1.10July2015
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                        <br />
                        </p>
                        <p
                        className="s7"
                        style={{
                            paddingLeft: "25pt",
                            textIndent: "0pt",
                            lineHeight: "114%",
                            textAlign: "justify",
                        }}
                        >
                        interception, modification or amendment by unauthorized persons and
                        the client acknowledges that transmission may be disrupted,
                        interrupted, delayed or incorrect. The client shall not hold UOBKH
                        responsible for any errors, viruses, delay, inaccuracy, losses,
                        damages whatsoever arising from or in connection with the client use
                        of the Service including but not limited to any interception,
                        modification or amendment, disruption, interruption, delay or
                        inaccuracy of e-mails or internet transmission or other
                        communication equipment or facilities. For the avoidance of doubt,
                        UOBKH shall not be responsible for any losses suffered whether
                        direct, indirect, consequential, or special loss, even if the UOBKH
                        shall have been advised of the same.
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "9pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client will not hold UOBKH responsible for any consequences that
                        may arise as a result of any online communication between the client
                        and UOBKH which may be lost in transmission (whether in whole or in
                        part).
                        </p>
                    </li>
                    <li
                        style={{
                        paddingTop: "10pt",
                        paddingLeft: "26pt",
                        textIndent: "0pt",
                        lineHeight: "114%",
                        textAlign: "justify",
                        }}
                    >
                        <p className="s7" style={{ display: "inline" }}>
                        The client acknowledges and agrees that UOBKH shall have the right
                        to amend any term(s) of this agreement at any time by giving such
                        notice in writing to the client, whether by mail, facsimile, e-mail
                        notification or otherwise or by placing prominent notices at UOBKH's
                        branches and/or UOBKH's website and the client agrees to be bound by
                        the same.
                        </p>
                    </li>
                    </ol>
                </div>
            </div>
            <div className='pt-5'>
                <Checkbox onChange={onChange}>
                    <b>I CONFIRM THAT I UNDERSTAND THE TERMS AND CONDITIONS AS SET OUT IN THE ONLINE FACILITIES AGREEMENT AND I HEREBY ACCEPT AND AGREE TO THE SAME.</b>
                </Checkbox>
              
            </div>
            <div className='pt-3'>
                <Button  className='btn-primary-custom btn-md' disabled={!checked}  onClick={onClick}>
                    Next
                </Button>
            </div>
        </div>
      );
      
};

export default Index;
